import React from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import * as Styled from './styled';

function StyledSwitch({
  checked,
  onCheckedChange,
  leftText,
  rightText,
  checkedIcon,
  uncheckedIcon,
  height,
  width,
  handleDiameter,
  onColor,
  onHandleColor,
  offHandleColor,
  activeBoxShadow,
  TextContainer,
  toggleOnTextClick,
  className,
}) {
  return (
    <Styled.SwitchBody className={className}>
      {leftText && <Styled.SwitchText>{leftText}</Styled.SwitchText>}
      <Switch
        onChange={onCheckedChange}
        checked={checked}
        checkedIcon={checkedIcon}
        uncheckedIcon={uncheckedIcon}
        height={height}
        width={width}
        handleDiameter={handleDiameter || height - 4}
        onColor={onColor}
        onHandleColor={onHandleColor}
        offHandleColor={offHandleColor}
        activeBoxShadow={activeBoxShadow}
        aria-label={leftText || rightText}
      />
      {rightText && (
        <TextContainer
          onClick={
            toggleOnTextClick ? () => onCheckedChange(!checked) : undefined
          }
        >
          {rightText}
        </TextContainer>
      )}
    </Styled.SwitchBody>
  );
}

StyledSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onCheckedChange: PropTypes.func.isRequired,
  leftText: PropTypes.string,
  rightText: PropTypes.string,
  uncheckedIcon: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  checkedIcon: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  height: PropTypes.number,
  width: PropTypes.number,
  handleDiameter: PropTypes.number,
  onColor: PropTypes.string,
  onHandleColor: PropTypes.string,
  offHandleColor: PropTypes.string,
  activeBoxShadow: PropTypes.string,
  TextContainer: PropTypes.elementType,
  toggleOnTextClick: PropTypes.bool,
  className: PropTypes.string,
};

StyledSwitch.defaultProps = {
  leftText: null,
  rightText: null,
  checkedIcon: false,
  uncheckedIcon: false,
  height: 15,
  width: 30,
  handleDiameter: undefined,
  onColor: '#BFDEAB',
  onHandleColor: '#6DB33F',
  offHandleColor: '#AAAAAA',
  activeBoxShadow: '0 0 2px 3px #6DB33F',
  TextContainer: Styled.SwitchText,
  toggleOnTextClick: false,
  className: null,
};

export default StyledSwitch;
